import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { LOGO_FULL, NAV_LINKS, WHATSAPP_DISPLAY, WHATSAPP_LINK } from "@/lib/constants";

const Footer = () => (
    <footer data-testid="site-footer" className="grain-overlay relative bg-navy-ink text-slate-300">
        <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-20">
            <div className="grid gap-12 md:grid-cols-12">
                <div className="md:col-span-5">
                    <img src={LOGO_FULL} alt="Vorantis Soluções" className="h-10 w-auto" />
                    <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
                        Gestão, processos e posicionamento digital para empresas que desejam
                        organizar a operação, fortalecer a presença no mercado e crescer com direção.
                    </p>
                    <p className="mt-6 font-mono text-[11px] font-semibold uppercase tracking-[0.3em] text-emerald-500">
                        Movimento • Evolução • Soluções
                    </p>
                </div>
                <div className="md:col-span-3">
                    <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-slate-500">Navegação</p>
                    <nav className="mt-5 flex flex-col gap-3" aria-label="Rodapé">
                        {NAV_LINKS.map((link) => (
                            <Link
                                key={link.path}
                                to={link.path}
                                data-testid={`footer-${link.testid}`}
                                className="text-sm text-slate-400 transition-colors hover:text-emerald-400"
                            >
                                {link.label}
                            </Link>
                        ))}
                    </nav>
                </div>
                <div className="md:col-span-4">
                    <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-slate-500">Contato</p>
                    <div className="mt-5 flex flex-col gap-4 text-sm">
                        <a
                            href={WHATSAPP_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-whatsapp-link"
                            className="inline-flex items-center gap-2 font-semibold text-white transition-colors hover:text-emerald-400"
                        >
                            WhatsApp: {WHATSAPP_DISPLAY}
                        </a>
                        <span className="inline-flex items-center gap-2 text-slate-400">
                            <MapPin size={16} className="text-emerald-500" />
                            Barra Mansa • RJ — Sul Fluminense
                        </span>
                    </div>
                </div>
            </div>
            <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-slate-500 md:flex-row md:items-center md:justify-between">
                <span>© {new Date().getFullYear()} Vorantis Soluções. Todos os direitos reservados.</span>
                <span>Dados pessoais tratados conforme a LGPD (Lei nº 13.709/2018).</span>
            </div>
        </div>
    </footer>
);

export default Footer;
